"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeTab = void 0;
var react_1 = __importDefault(require("react"));
require("./index.less");
/**
 *
 * @param props
 * @returns
 */
function FakeTab(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "fake_tab_box" },
            react_1.default.createElement("ul", null, props.tabs && props.tabs.map(function (v, i) {
                return react_1.default.createElement("li", { key: i, className: v.on ? "on" : "" },
                    !v.link && react_1.default.createElement("span", null, v.txt),
                    v.link && react_1.default.createElement("a", { href: v.link, target: "_blank" }, v.txt));
            })),
            react_1.default.createElement("div", { className: "fr" }, props.right))));
}
exports.FakeTab = FakeTab;
